import Badge from '../components/template/Badge';
import BaseAlert from '../components/template/BaseAlert';
import BaseButton from '../components/template/BaseButton';
import BaseCheckbox from '../components/template/BaseCheckbox';
import BaseInput from '../components/template/BaseInput';
import BaseDropdown from '../components/template/BaseDropdown';
import BaseNav from '../components/template/BaseNav';
import BasePagination from '../components/template/BasePagination';
import BaseProgress from '../components/template/BaseProgress';
import BaseRadio from '../components/template/BaseRadio';
import BaseSlider from '../components/template/BaseSlider';
import BaseSwitch from '../components/template/BaseSwitch';
import BaseTable from '../components/template/BaseTable';
import BaseHeader from '../components/template/BaseHeader';
import Card from '../components/template/Card';
import StatsCard from '../components/template/StatsCard';
import Modal from '../components/template/Modal';
import TabPane from '../components/template/Tabs/TabPane';
import Tabs from '../components/template/Tabs/Tabs';

export default {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseNav.name, BaseNav);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseSlider.name, BaseSlider);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(BaseTable.name, BaseTable);
    Vue.component(BaseHeader.name, BaseHeader);
    Vue.component(Card.name, Card);
    Vue.component(StatsCard.name, StatsCard);
    Vue.component(Modal.name, Modal);
    Vue.component(TabPane.name, TabPane);
    Vue.component(Tabs.name, Tabs);
  }
};



// WEBPACK FOOTER //
// ./src/plugins/globalComponents.js